const normalize = (value) => String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export function matchesPayrollTaxCardFilter(row, filter) {
  if (filter === 'all') return true;
  if (row.taxCardSource === 'danlon_browser') {
    return row.taxCardStatus === ({ yes: 'received', no: 'missing' }[filter] || filter);
  }
  return filter === 'yes' ? row.taxCardReceived === true : filter === 'no' ? row.taxCardReceived === false : false;
}

export function matchesPayrollSearch(row, query) {
  let text = normalize(query).trim();
  if (!text) return true;
  const syncedTaxCard = row.taxCardSource === 'danlon_browser';
  const conditions = [
    [/\b(?:pending tax card|tax card pending)\b/g, row.taxCardStatus === 'pending'],
    [/\b(?:unknown tax card|tax card unknown)\b/g, row.taxCardStatus === 'unknown'],
    [/\b(?:stale tax card|tax card stale)\b/g, row.taxCardStatus === 'stale'],
    [/\b(?:no tax card|without tax card|intet skattekort)\b/g, syncedTaxCard ? row.taxCardStatus === 'missing' : row.taxCardReceived === false],
    [/\b(?:with tax card|tax card|skattekort)\b/g, syncedTaxCard ? row.taxCardStatus === 'received' : row.taxCardReceived === true],
    [/\bdanl[oø]n inactive\b/g, row.danlonActive === false],
    [/\bdanl[oø]n active\b/g, row.danlonActive === true],
    [/\b(?:tempus )?(?:inactive|inaktiv)\b/g, row.tempusActive === false],
    [/\b(?:tempus )?(?:active|aktiv)\b/g, row.tempusActive === true],
  ];
  for (const [pattern, matches] of conditions) {
    if (text.match(pattern)) {
      if (!matches) return false;
      text = text.replace(pattern, ' ').trim();
    }
  }
  const words = [row.name, row.cpr, String(row.cpr || '').replace(/\D/g, ''), row.medarbNr, row.note,
    row.taxCardStatus, row.taxCardProviderStatus, row.taxCardObservedAt, syncedTaxCard ? 'danlon fetched' : 'manual',
    row.tempusActive ? 'active aktiv' : 'inactive inaktiv',
    row.danlonActive === true ? 'danlon active' : row.danlonActive === false ? 'danlon inactive' : 'danlon unknown',
    row.employedInMonth ? 'employed ansat' : 'former tidligere',
    row.vacationTaken ? 'vacation ferie' : '',
    ...(row.placements || []).map((p) => p.customerName || p.customer?.companyName || p.customer?.name || ''),
    ...(row.customers || []).map((c) => c.name || c.companyName || ''),
    ...Object.values(row).filter((v) => typeof v === 'number').flatMap((v) => [v, v.toLocaleString('da-DK')]),
  ].map(normalize).join(' ');
  return words.includes(text.replace(/\s+/g, ' '));
}
